import { AgentAdminFormComponent } from './pages-private/agent/agent-admin/agent-admin-form/agent-admin-form.component';
import { DynamicEntityViewComponent } from './pages-private/dynamic-entity/dynamic-entity-view/dynamic-entity-view.component';
import { forwardRef, NgModule } from '@angular/core';
import {
	BrowserModule,
	provideClientHydration,
} from '@angular/platform-browser';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { AppComponent } from './app.component';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import {
	FaIconLibrary,
	FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import {
	FormsModule,
	NG_VALUE_ACCESSOR,
	ReactiveFormsModule,
} from '@angular/forms';
import { LoginComponent } from './pages-public/login/login.component';
import { MainLayoutComponent } from './pages-private/main-layout/main-layout.component';
import {
	provideHttpClient,
	withInterceptorsFromDi,
} from '@angular/common/http';
import {
	NgbDropdownModule,
	NgbCollapseModule,
	NgbProgressbarModule,
} from '@ng-bootstrap/ng-bootstrap';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import {
	NzMenuModule,
	NzSubmenuNoneInlineChildComponent,
} from 'ng-zorro-antd/menu';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzMessageContainerComponent } from 'ng-zorro-antd/message';
import { BlockedComponent } from './pages-public/login/modes/blocked/blocked.component';
import { SuspendedComponent } from './pages-public/login/modes/suspended/suspended.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { AccessControlComponent } from './components/access-control/access-control.component';
import { HasPermissionDirective } from './components/has-permission.directive';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { FocusDirective } from './components/focus.directive';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzButtonModule } from 'ng-zorro-antd/button';
import {
	HighchartsChartComponent,
	provideHighcharts,
} from 'highcharts-angular';
import { LoginFormComponent } from './pages-public/login/modes/login-form/login-form.component';
import { ForgotPasswordFormComponent } from './pages-public/login/modes/forgot-password-form/forgot-password-form.component';
import { HomeComponent } from './pages-private/home/home.component';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { DynamicEntityListComponent } from './pages-private/dynamic-entity/dynamic-entity-list/dynamic-entity-list.component';
import { DynamicEntityModalComponent } from './pages-private/dynamic-entity/dynamic-entity-modal/dynamic-entity-modal.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { DynamicFormListComponent } from './components/dynamic-form/list/dynamic-form-list.component';
import { DynamicFormBuilderComponent } from './components/dynamic-form/builder/dynamic-form-builder.component';
import { DftSingleColumnComponent } from './components/dynamic-form/templates/dft-single-column/dft-single-column.component';
import { DftDualColumnComponent } from './components/dynamic-form/templates/dft-dual-column/dft-dual-column.component';
import { AgentAdminListComponent } from './pages-private/agent/agent-admin/agent-admin-list/agent-admin-list.component';
import { AgentFaoListComponent } from './pages-private/agent/agent-fao/agent-fao-list/agent-fao-list.component';
import { AgentFaoFormComponent } from './pages-private/agent/agent-fao/agent-fao-form/agent-fao-form.component';
import { AgentUnderwriterListComponent } from './pages-private/agent/agent-underwriter/agent-underwriter-list/agent-underwriter-list.component';
import { AgentUnderwriterFormComponent } from './pages-private/agent/agent-underwriter/agent-underwriter-form/agent-underwriter-form.component';
import { MemberListComponent } from './pages-private/member/member-list/member-list.component';
import { MemberFormComponent } from './pages-private/member/member-form/member-form.component';
import { DynamicEntityFieldSelectorComponent } from './pages-private/dynamic-entity/dynamic-entity-field-selector/dynamic-entity-field-selector.component';
import { PendingChangesGuard } from './components/pending-changes.guard';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { DynamicFormInputTextComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-text/dynamic-form-input-text.component';
import { DynamicFormInputNumberComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-number/dynamic-form-input-number.component';
import { DynamicFormInputDropDownComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-drop-down/dynamic-form-input-drop-down.component';
import { DynamicFormInputBooleanComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-boolean/dynamic-form-input-boolean.component';
import { DynamicFormInputDateComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-date/dynamic-form-input-date.component';
import { DynamicFormInputTimeComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-time/dynamic-form-input-time.component';
import { DynamicFormInputDatetimeComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-datetime/dynamic-form-input-datetime.component';
import { DynamicFormInputFileComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-file/dynamic-form-input-file.component';
import { DynamicFormInputPasswordComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-password/dynamic-form-input-password.component';
import { DynamicFormInputEmailComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-email/dynamic-form-input-email.component';
import { DynamicFormInputMsisdnComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-msisdn/dynamic-form-input-msisdn.component';
import { DynamicFormInputSubDynamicComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-sub-dynamic/dynamic-form-input-sub-dynamic.component';
import { WorkflowListComponent } from './pages-private/workflow/workflow-list/workflow-list.component';
import { WorkflowFormComponent } from './pages-private/workflow/workflow-form/workflow-form.component';
import { WorkflowFormStepComponent } from './pages-private/workflow/workflow-form/components/workflow-form-step/workflow-form-step.component';
import { WorkflowFormSectionComponent } from './pages-private/workflow/workflow-form/components/workflow-form-section/workflow-form-section.component';
import { WorkflowFormElementComponent } from './pages-private/workflow/workflow-form/components/workflow-form-element/workflow-form-element.component';
import { WorkflowFormButtonComponent } from './pages-private/workflow/workflow-form/components/workflow-form-button/workflow-form-button.component';
import { WorkflowFormActionComponent } from './pages-private/workflow/workflow-form/components/workflow-form-action/workflow-form-action.component';
import { DynamicFormInputServiceProviderIdComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-service-provider-id/dynamic-form-input-service-provider-id.component';
import {
	BrowserAnimationsModule,
	provideAnimations,
} from '@angular/platform-browser/animations';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { InvalidFormIndicatorComponent } from './pages-private/workflow/workflow-form/components/invalid-form-indicator/invalid-form-indicator.component';
import { DynamicFormInputTextareaComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-textarea/dynamic-form-input-textarea.component';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { InvalidFormDrawerComponent } from './pages-private/workflow/workflow-form/components/invalid-form-drawer/invalid-form-drawer.component';
import { TicketMemberSearchComponent } from './pages-private/tickets/ticket-member-search/ticket-member-search.component';
import { DftCardComponent } from './components/dynamic-form/templates/dft-card/dft-card.component';
import { ComposeNotificationComponent } from './components/compose-notification/compose-notification.component';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { EmailBodyEditorComponent } from './components/email-body-editor/email-body-editor.component';
import { EmployerListComponent } from './pages-private/employer/employer-list/employer-list.component';
import { EmployerFormComponent } from './pages-private/employer/employer-form/employer-form.component';
import { CategoryListComponent } from './pages-private/category/category-list/category-list.component';
import { CategoryFormComponent } from './pages-private/category/category-form/category-form.component';
import { NzListModule } from 'ng-zorro-antd/list';
import { TicketReportListComponent } from './pages-private/tickets/ticket-report/ticket-report-list/ticket-report-list.component';
import { TicketReportFormComponent } from './pages-private/tickets/ticket-report/ticket-report-form/ticket-report-form.component';
import { MemberBulkUploadComponent } from './pages-private/member/member-bulk-upload/member-bulk-upload.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RoleListComponent } from './pages-private/role/role-list/role-list.component';
import { RoleEditComponent } from './pages-private/role/role-edit/role-edit.component';
import { PermissionComponent } from './pages-private/permission/permission.component';
import { WorkflowRoleListComponent } from './pages-private/workflow/workflow-role-list/workflow-role-list.component';
import { WorkflowRoleEditComponent } from './pages-private/workflow/workflow-role-edit/workflow-role-edit.component';
import { MemberViewComponent } from './pages-private/member/member-view/member-view.component';
import { MemberViewDetailsComponent } from './pages-private/member/member-view/components/member-view-details/member-view-details.component';
import { NzSpaceComponent } from 'ng-zorro-antd/space';
import { MemberBulkUploadListComponent } from './pages-private/member/member-bulk-upload-list/member-bulk-upload-list.component';
import { MemberBulkUploadFormComponent } from './pages-private/member/member-bulk-upload-form/member-bulk-upload-form.component';
import { MemberBulkUploadViewComponent } from './pages-private/member/member-bulk-upload-view/member-bulk-upload-view.component';
import { TicketReportFormSimpleModalComponent } from './pages-private/tickets/ticket-report/ticket-report-form-simple-modal/ticket-report-form-simple-modal.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TicketReportRunModalComponent } from './pages-private/tickets/ticket-report/ticket-report-run-modal/ticket-report-run-modal.component';
import { WithoutPermissionDirective } from './components/without-permission.directive';
import { TicketReportFormSubColumnModalComponent } from './pages-private/tickets/ticket-report/ticket-report-form-sub-column-modal/ticket-report-form-sub-column-modal.component';
import { TicketListComponent } from './pages-private/tickets/ticket-list/ticket-list.component';
import { TicketFormComponent } from './pages-private/tickets/tickets-form/ticket-form.component';
import { TicketFormSectionImagesComponent } from './pages-private/tickets/tickets-form/components/ticket-form-section-images/ticket-form-section-images.component';
import { TicketCommunicationModalComponent } from './pages-private/tickets/tickets-form/components/ticket-communication-modal/ticket-communication-modal.component';
import { TicketAdditionalCommentComponent } from './pages-private/tickets/tickets-form/components/ticket-additional-comment/ticket-additional-comment.component';
import { TicketHistoryComponent } from './pages-private/tickets/tickets-form/components/ticket-history/ticket-history.component';
import { MemberViewClaimsComponent } from './pages-private/member/member-view/components/member-view-claims/member-view-claims.component';
import { TicketAssignModalComponent } from './pages-private/tickets/tickets-assign-modal/ticket-assign-modal.component';
import { TicketDashboardComponent } from './pages-private/tickets/ticket-dashboard/ticket-dashboard.component';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { AwsQuicksiteComponent } from './components/aws-quicksite/aws-quicksite.component';
import { DashboardTotalComponent } from './pages-private/dashboard/dashboard-total/dashboard-total.component';

import { CommunicationSendComponent } from './pages-private/communication/send/communication-send.component';
import { CommunicationScheduledAutomatedComponent } from './pages-private/communication/scheduled-automated/communication-scheduled-automated.component';
import { CommunicationLogComponent } from './pages-private/communication/log/communication-log.component';
import { RecipientFilterModalComponent } from './pages-private/communication/send/recipient-filter-modal/recipient-filter-modal.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CloseOutline } from '@ant-design/icons-angular/icons';
import { IconDefinition } from '@ant-design/icons-angular';
import { ScheduleModalComponent } from './pages-private/communication/send/schedule-modal/schedule-modal.component';
import { CommunicationConfirmationModalComponent } from './pages-private/communication/send/confirmation-modal/communication-confirmation-modal.component';
import { FilterInfoComponent } from './pages-private/communication/filter-info/filter-info.component';
import { ScheduleInfoComponent } from './pages-private/communication/schedule-info/schedule-info.component';
import { CommunicationReportComponent } from './pages-private/communication/report/communication-report.component';
import { TicketDuplicateWarningModalComponent } from './pages-private/tickets/tickets-form/components/ticket-duplicate-warning-modal/ticket-duplicate-warning-modal.component';
import { NzFloatButtonModule } from 'ng-zorro-antd/float-button';
import { AiChatWidgetComponent } from './components/ai-chat-widget/ai-chat-widget.component';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { AgentAdminViewComponent } from './pages-private/agent/agent-admin/agent-admin-view/agent-admin-view.component';
import { AgentViewClaimsComponent } from './pages-private/agent/agent-admin/agent-admin-view/components/agent-view-tickets/agent-view-tickets.component';
import { AgentViewDetailsComponent } from './pages-private/agent/agent-admin/agent-admin-view/components/agent-view-details/agent-view-details.component';
import { AgentAdminViewAppRolesComponent } from './pages-private/agent/agent-admin/agent-admin-view/components/agent-admin-view-app-roles/agent-admin-view-app-roles.component';
import { AgentAdminViewTicketRolesComponent } from './pages-private/agent/agent-admin/agent-admin-view/components/agent-admin-view-ticket-roles/agent-admin-view-ticket-roles.component';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { EmployerViewComponent } from './pages-private/employer/employer-view/employer-view.component';
import { EmployerViewDetailsComponent } from './pages-private/employer/employer-view/components/employer-view-details/employer-view-details.component';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { DashboardComponent } from './pages-private/dashboard/dashboard/dashboard.component';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { HierarchyInputComponent } from './components/hierarchy-input/hierarchy-input.component';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { DynamicFormInputHierarchyComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-hierarchy/dynamic-form-input-hierarchy.component';
import { BankListComponent } from './pages-private/bank/bank-list/bank-list.component';
import { BankFormComponent } from './pages-private/bank/bank-form/bank-form.component';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzResultModule } from 'ng-zorro-antd/result';
import { TicketFormSectionOperationsComponent } from './pages-private/tickets/tickets-form/components/ticket-form-section-operations/ticket-form-section-operations.component';
import { AnalyticsListComponent } from './pages-private/analytics/analytics-list/analytics-list.component';
import { AgentSelfComponent } from './pages-private/agent/agent-self/agent-self.component';
import { TicketSearchModalComponent } from './pages-private/tickets/ticket-search-modal/ticket-search-modal.component';
import { PreviewModalComponent } from './components/preview-modal/preview-modal.component';
import { AnalyticsLandingPageComponent } from './pages-private/analytics/analytics-landing-page/analytics-landing-page.component';
import { TableComponent } from './components/table/table.component';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { ProductListComponent } from './pages-private/insurance/product/product-list/product-list.component';
import { ProductViewComponent } from './pages-private/insurance/product/product-view/product-view.component';
import { ProductEditComponent } from './pages-private/insurance/product/product-edit/product-edit.component';
import { ProductScheduleListComponent } from './pages-private/insurance/product-schedule/product-schedule-list/product-schedule-list.component';
import { ProductScheduleViewComponent } from './pages-private/insurance/product-schedule/product-schedule-view/product-schedule-view.component';
import { BankDepositListComponent } from './pages-private/insurance/bank-deposit/bank-deposit-list/bank-deposit-list.component';
import { BankDepositViewComponent } from './pages-private/insurance/bank-deposit/bank-deposit-view/bank-deposit-view.component';
import { PolicyPaymentListComponent } from './pages-private/insurance/policy-payment/policy-payment-list/policy-payment-list.component';
import { PolicyPaymentViewComponent } from './pages-private/insurance/policy-payment/policy-payment-view/policy-payment-view.component';
import { BankPaymentListComponent } from './pages-private/insurance/bank-payment/bank-payment-list/bank-payment-list.component';
import { BankPaymentViewComponent } from './pages-private/insurance/bank-payment/bank-payment-view/bank-payment-view.component';
import { RouteOutletPassthroughComponent } from './route-outlet-passthrough.component';
// import { BenefitPaymentApprovalViewComponent } from './pages-private/insurance/benefit-payment-approval/benefit-payment-approval-view/benefit-payment-approval-view.component';
import { BenefitPaymentApprovalSettingComponent } from './pages-private/insurance/benefit-payment-approval/benefit-payment-approval-setting/benefit-payment-approval-setting.component';
import { TicketMemberSearchByPolicyComponent } from './pages-private/tickets/ticket-member-search/components/ticket-member-search-by-policy/ticket-member-search-by-policy.component';
import { TicketMemberSearchByMemberComponent } from './pages-private/tickets/ticket-member-search/components/ticket-member-search-by-member/ticket-member-search-by-member.component';
import { TicketPickerComponent } from './pages-private/tickets/ticket-member-search/components/ticket-picker/ticket-picker.component';
import { BenefitPaymentListComponent } from './pages-private/insurance/benefit-payment-list/benefit-payment-list.component';
import { BenefitPaymentApprovalListComponent } from './pages-private/insurance/benefit-payment-approval-list/benefit-payment-approval-list.component';
import { ProductEditRuleModalComponent } from './pages-private/insurance/product/product-edit/components/product-edit-rule-modal/product-edit-rule-modal.component';
import { ProductEditOfferModalComponent } from './pages-private/insurance/product/product-edit/components/product-edit-offer-modal/product-edit-offer-modal.component';
import { ProductEditExtendedModalComponent } from './pages-private/insurance/product/product-edit/components/product-edit-extended-modal/product-edit-extended-modal.component';
import { DynamicGenericEntityFormComponent } from './pages-private/dynamic-generic-entity/dynamic-generic-entity-form/dynamic-generic-entity-form.component';
import { DynamicGenericEntityListComponent } from './pages-private/dynamic-generic-entity/dynamic-generic-entity-list/dynamic-generic-entity-list.component';
import { DynamicFormInputDependantListComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-dependant-list/dynamic-form-input-dependant-list.component';
import { ProductEditBankAccountModalComponent } from './pages-private/insurance/product/product-edit/components/product-edit-bank-account-modal/product-edit-bank-account-modal.component';

import { TicketCommunicationDisplayModalComponent } from './pages-private/tickets/tickets-form/components/ticket-communication-display-modal/ticket-communication-display-modal.component';
import { TicketsViewHistoryComponent } from './pages-private/tickets/tickets-view-history/tickets-view-history.component';
import { PolicyNewComponent } from './pages-private/insurance/policy/policy-new/policy-new.component';
import { PolicyExtendedCoverModalComponent } from './pages-private/insurance/policy/components/policy-extended-cover-modal/policy-extended-cover-modal.component';
import { PolicyEditComponent } from './pages-private/insurance/policy/policy-edit/policy-edit.component';
import { PolicySearchModalComponent } from './pages-private/insurance/policy/policy-search-modal/policy-search-modal.component';
import { MemberViewPoliciesComponent } from './pages-private/member/member-view/components/member-view-policies/member-view-policies.component';
import { DynamicFormInputIdNumberOfLivingPersonComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-id-number-of-living-person/dynamic-form-input-id-number-of-living-person.component';
import { DynamicFormInputIdNumberOfDeceasedPersonComponent } from './components/dynamic-form/templates/inputs/dynamic-form-input-id-number-of-deceased-person/dynamic-form-input-id-number-of-deceased-person.component';
import { TicketQuestionnaireFormComponent } from './pages-private/tickets/tickets-form/components/ticket-questionnaire-form/ticket-questionnaire-form.component';
import { TicketQuestionnaireViewComponent } from './pages-private/tickets/tickets-form/components/ticket-questionnaire-view/ticket-questionnaire-view.component';
import { TwoFactorAuthComponent } from './pages-public/login/modes/two-factor-auth/two-factor-auth.component';
import { FinanceHomeComponent } from './pages-private/finance/finance-home/finance-home.component';
import { FinanceProductViewComponent } from './pages-private/finance/finance-product-view/finance-product-view.component';
import { FinanceProductCaptureDepositAmountComponent } from './pages-private/finance/finance-product-view/components/finance-product-capture-deposit-amount/finance-product-capture-deposit-amount.component';
import { FinanceProductScheduleFormatComponent } from './pages-private/finance/finance-product-view/components/finance-product-schedule-format/finance-product-schedule-format.component';
import { PolicyAddDependantModalComponent } from './pages-private/insurance/policy/components/policy-add-dependant-modal/policy-add-dependant-modal.component';
import { FinanceProductScheduleProgressComponent } from './pages-private/finance/finance-product-view/components/finance-product-schedule-progress/finance-product-schedule-progress.component';
import { DynamicFormInputIcd10Component } from './components/dynamic-form/templates/inputs/dynamic-form-input-icd10/dynamic-form-input-icd10.component';
import { PolicyBeneficiaryModalComponent } from './pages-private/insurance/policy/components/policy-beneficiary-modal/policy-beneficiary-modal.component';
import { ForcePasswordChangeComponent } from './components/force-password-change/force-password-change.component';
import { LayoutModule } from '@angular/cdk/layout';
import { DashboardChartBarComponent } from './pages-private/dashboard/components/dashboard-chart-bar/dashboard-chart-bar.component';
import { DashboardChartLineComponent } from './pages-private/dashboard/components/dashboard-chart-line/dashboard-chart-line.component';
import { DashboardChartPieComponent } from './pages-private/dashboard/components/dashboard-chart-pie/dashboard-chart-pie.component';
import { DashboardChartGaugeComponent } from './pages-private/dashboard/components/dashboard-chart-gauge/dashboard-chart-gauge.component';
import { DashboardChartScatterComponent } from './pages-private/dashboard/components/dashboard-chart-scatter/dashboard-chart-scatter.component';
import { DashboardTableComponent } from './pages-private/dashboard/components/dashboard-table/dashboard-table.component';
import { DashboardEditorComponent } from './pages-private/dashboard/dashboard-editor/dashboard-editor.component';
import { DashboardListComponent } from './pages-private/dashboard/dashboard-list/dashboard-list.component';
import { GridsterModule } from 'angular-gridster2';
import { DashboardComponentListComponent } from './pages-private/dashboard/dashboard-component-list/dashboard-component-list.component';
import { DashboardComponentEditorComponent } from './pages-private/dashboard/dashboard-component-editor/dashboard-component-editor.component';
import { TicketInvoiceApprovalListComponent } from './pages-private/invoice/ticket-invoice-approval-list/ticket-invoice-approval-list.component';
import { TicketInvoiceApprovalSettingComponent } from './pages-private/invoice/ticket-invoice-approval-setting/ticket-invoice-approval-setting.component';
import { TicketInvoiceListComponent } from './pages-private/invoice/ticket-invoice-list/ticket-invoice-list.component';
import { SbPublicComponent } from './pages-public/sb-public/sb-public.component';
import { SbDisabilityComponent } from './pages-public/sb-disability/sb-disability.component';
import { SbStilComponent } from './pages-public/sb-stil/sb-stil.component';
import * as echarts from 'echarts';
import { NgxEchartsModule, provideEchartsCore } from 'ngx-echarts';

registerLocaleData(en);
const routes: Routes = [
	// { path: 'home', component: HomeComponent},
	// { path: 'home', component: HomeComponent },
	{ path: 'sb', component: SbPublicComponent },
	{ path: 'sb-disability', component: SbDisabilityComponent },
	{ path: 'sb-stil', component: SbStilComponent },

	{ path: 'dashboard/total', component: DashboardTotalComponent },
	{ path: 'dashboard/list', component: DashboardListComponent },
	{ path: 'dashboard/:id/edit', component: DashboardEditorComponent },
	{ path: 'dashboard', component: DashboardComponent },

	{ path: 'dynamic/list', component: DynamicEntityListComponent },
	{
		path: 'dynamic/:id',
		component: DynamicEntityViewComponent,
		canDeactivate: [PendingChangesGuard],
	},

	{
		path: 'dynamic/:type/list',
		component: DynamicGenericEntityListComponent,
	},
	{ path: 'dynamic/:type/new', component: DynamicGenericEntityFormComponent },
	{
		path: 'dynamic/:type/:id/edit',
		component: DynamicGenericEntityFormComponent,
	},
	{ path: 'form/list', component: DynamicFormListComponent },
	{ path: 'form/new', component: DynamicFormBuilderComponent },

	{ path: 'workflow/list', component: WorkflowListComponent },
	{
		path: 'workflow/new',
		component: WorkflowFormComponent,
		canDeactivate: [PendingChangesGuard],
	},
	{
		path: 'workflow/:id',
		component: WorkflowFormComponent,
		canDeactivate: [PendingChangesGuard],
	},

	{ path: 'workflow_role/list', component: WorkflowRoleListComponent },
	{ path: 'workflow_role/new', component: WorkflowRoleEditComponent },
	{
		path: 'workflow_role/:workflowRoleId/edit',
		component: WorkflowRoleEditComponent,
	},

	{ path: 'agent/self', component: AgentSelfComponent },
	{ path: 'agent/admin/list', component: AgentAdminListComponent },
	{ path: 'agent/admin/new', component: AgentAdminFormComponent },
	{ path: 'agent/admin/:id/edit', component: AgentAdminFormComponent },
	{ path: 'agent/admin/:agentId/view', component: AgentAdminViewComponent },
	{ path: 'agent/fao/list', component: AgentFaoListComponent },
	{ path: 'agent/fao/new', component: AgentFaoFormComponent },
	{ path: 'agent/fao/:id/edit', component: AgentFaoFormComponent },
	{
		path: 'agent/underwriter/list',
		component: AgentUnderwriterListComponent,
	},
	{ path: 'agent/underwriter/new', component: AgentUnderwriterFormComponent },
	{
		path: 'agent/underwriter/:id/edit',
		component: AgentUnderwriterFormComponent,
	},

	{ path: 'member/list', component: MemberListComponent },
	{ path: 'member/new', component: MemberFormComponent },
	{ path: 'member/:memberId/edit', component: MemberFormComponent },
	{ path: 'member/:memberId/view', component: MemberViewComponent },
	{ path: 'member/bulk/list', component: MemberBulkUploadListComponent },
	{ path: 'member/bulk/new', component: MemberBulkUploadFormComponent },
	{ path: 'member/bulk/:id/view', component: MemberBulkUploadViewComponent },

	{ path: 'category/list', component: CategoryListComponent },
	{ path: 'category/new', component: CategoryFormComponent },
	{ path: 'category/:id/edit', component: CategoryFormComponent },
	{ path: 'employer/list', component: EmployerListComponent },
	{ path: 'employer/new', component: EmployerFormComponent },
	{ path: 'employer/:employerId/edit', component: EmployerFormComponent },
	{ path: 'employer/:employerId/view', component: EmployerViewComponent },

	{
		path: 'ticket/invoice/approval/list',
		component: TicketInvoiceApprovalListComponent,
	},
	{
		path: 'ticket/invoice/approval/setting',
		component: TicketInvoiceApprovalSettingComponent,
	},
	{ path: 'ticket/invoice/list', component: TicketInvoiceListComponent },

	{
		path: 'ticket/:ticketId/history',
		component: TicketsViewHistoryComponent,
	},
	{ path: 'ticket/report/list', component: TicketReportListComponent },
	{
		path: 'ticket/report/:workflowId/list',
		component: TicketReportListComponent,
	},
	{
		path: 'ticket/report/:workflowId/new',
		component: TicketReportFormComponent,
	},
	{
		path: 'ticket/report/:reportId/edit',
		component: TicketReportFormComponent,
	},

	{
		path: 'ticket/:ticketMode/member-search',
		component: TicketMemberSearchComponent,
	},

	{
		path: 'ticket/:ticketMode/dashboard',
		component: TicketDashboardComponent,
	},
	{ path: 'ticket/:ticketMode/list', component: TicketListComponent },
	{
		path: 'ticket/:ticketMode/:workflowId/list',
		component: TicketListComponent,
	},
	{
		path: 'ticket/:ticketMode/:workflowId/:stepId/list',
		component: TicketListComponent,
	},

	{
		path: 'ticket/:ticketMode/policy/:policyId',
		component: TicketFormComponent,
	},
	{
		path: 'ticket/:ticketMode/:workflowId/member/:memberId',
		component: TicketFormComponent,
	},
	{
		path: 'ticket/:ticketMode/:workflowId/member/:memberId/:categories',
		component: TicketFormComponent,
	},
	{
		path: 'ticket/:ticketMode/:workflowId/dependent/:dependentId',
		component: TicketFormComponent,
	},

	{ path: 'ticket/:ticketMode/:ticketId', component: TicketFormComponent },

	{ path: 'communication/send', component: CommunicationSendComponent },
	{ path: 'communication/send/:id', component: CommunicationSendComponent },
	{
		path: 'communication/scheduled-automated',
		component: CommunicationScheduledAutomatedComponent,
	},
	{ path: 'communication/log', component: CommunicationLogComponent },
	{
		path: 'communication/report/:id',
		component: CommunicationReportComponent,
	},

	{ path: 'permissions', component: PermissionComponent },
	{ path: 'role/list', component: RoleListComponent },
	{ path: 'role/new', component: RoleEditComponent },
	{ path: 'role/:roleId/edit', component: RoleEditComponent },

	{ path: 'bank/list', component: BankListComponent },
	{ path: 'bank/new', component: BankFormComponent },
	{ path: 'bank/:id/edit', component: BankFormComponent },

	{ path: 'analytics-list', component: AnalyticsListComponent },
	{
		path: 'analytics-landing-page',
		component: AnalyticsLandingPageComponent,
	},

	{ path: 'policy/new', component: PolicyNewComponent },
	{ path: 'policy/:policyId', component: PolicyEditComponent },

	{ path: 'policy/new', component: PolicyNewComponent },
	{ path: 'policy/:policyId', component: PolicyEditComponent },

	{ path: 'bank-deposit/list', component: BankDepositListComponent },
	{ path: 'bank-deposit/:id/view', component: BankDepositViewComponent },
	{ path: 'bank-payment/list', component: BankPaymentListComponent },
	{ path: 'bank-payment/:id/view', component: BankPaymentListComponent },

	{ path: 'finance/home', component: FinanceHomeComponent },
	{ path: 'finance/product/:id', component: FinanceProductViewComponent },

	{ path: 'product/list', component: ProductListComponent },
	{ path: 'product/new', component: ProductEditComponent },
	{
		path: 'product/:id/edit',
		component: ProductEditComponent,
		children: [
			{ path: '', redirectTo: 'details', pathMatch: 'full' },
			{
				path: 'workflow',
				component: RouteOutletPassthroughComponent,
				children: [
					{
						path: ':productType/edit',
						component: WorkflowFormComponent,
						data: { mode: 'ProductWorkflow' },
					},
					{
						path: ':productId/:productType/edit',
						component: WorkflowFormComponent,
						data: { mode: 'ProductWorkflow' },
					},
				],
			},
		],
	},
	{
		path: 'product/:productId/view',
		component: ProductViewComponent,
		children: [
			{ path: '', redirectTo: 'details', pathMatch: 'full' },
			{
				path: 'schedule',
				component: RouteOutletPassthroughComponent,
				children: [
					{ path: '', redirectTo: 'list', pathMatch: 'full' },
					{
						path: ':id/view',
						component: ProductScheduleViewComponent,
					},
					{ path: 'list', component: ProductScheduleListComponent },
				],
			},
		],
	},

	{
		path: 'benefit-payment/approval/setting',
		component: BenefitPaymentApprovalSettingComponent,
	},
	{
		path: 'benefit-payment/approval/list',
		component: BenefitPaymentApprovalListComponent,
	},
	{ path: 'benefit-payment/list', component: BenefitPaymentListComponent },

	// { path: '**', redirectTo: '/dashboard/total' }
	{ path: '**', redirectTo: '/analytics-landing-page' },
];

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		MainLayoutComponent,
		BlockedComponent,
		SuspendedComponent,
		TwoFactorAuthComponent,
		AccessControlComponent,
		HasPermissionDirective,
		WithoutPermissionDirective,
		FocusDirective,
		LoginFormComponent,
		ForgotPasswordFormComponent,
		HomeComponent,
		DynamicEntityListComponent,
		DynamicEntityViewComponent,
		DynamicEntityModalComponent,
		DynamicFormComponent,
		DynamicFormListComponent,
		DynamicFormBuilderComponent,
		DftSingleColumnComponent,
		DftDualColumnComponent,
		AgentAdminListComponent,
		AgentAdminFormComponent,
		AgentFaoListComponent,
		AgentFaoFormComponent,
		AgentUnderwriterListComponent,
		AgentUnderwriterFormComponent,
		MemberListComponent,
		MemberFormComponent,
		DynamicEntityFieldSelectorComponent,
		DynamicFormInputTextComponent,
		DynamicFormInputNumberComponent,
		DynamicFormInputDropDownComponent,
		DynamicFormInputBooleanComponent,
		DynamicFormInputDateComponent,
		DynamicFormInputTimeComponent,
		DynamicFormInputDatetimeComponent,
		DynamicFormInputFileComponent,
		DynamicFormInputPasswordComponent,
		DynamicFormInputEmailComponent,
		DynamicFormInputMsisdnComponent,
		DynamicFormInputSubDynamicComponent,
		WorkflowListComponent,
		WorkflowFormComponent,
		WorkflowFormStepComponent,
		WorkflowFormSectionComponent,
		WorkflowFormElementComponent,
		WorkflowFormButtonComponent,
		WorkflowFormActionComponent,
		InvalidFormIndicatorComponent,
		DynamicFormInputTextareaComponent,
		TicketListComponent,
		InvalidFormDrawerComponent,
		TicketMemberSearchComponent,
		TicketFormComponent,
		DftCardComponent,
		ComposeNotificationComponent,
		EmployerListComponent,
		EmployerFormComponent,
		CategoryListComponent,
		CategoryFormComponent,
		TicketFormSectionImagesComponent,
		TicketCommunicationModalComponent,
		TicketReportListComponent,
		TicketReportFormComponent,
		TicketAdditionalCommentComponent,
		CommunicationSendComponent,
		CommunicationScheduledAutomatedComponent,
		CommunicationLogComponent,
		CommunicationReportComponent,
		RecipientFilterModalComponent,
		ScheduleModalComponent,
		FilterInfoComponent,
		ScheduleInfoComponent,
		CommunicationConfirmationModalComponent,
		MemberBulkUploadComponent,
		TicketHistoryComponent,
		RoleListComponent,
		RoleEditComponent,
		PermissionComponent,
		WorkflowRoleListComponent,
		WorkflowRoleEditComponent,
		MemberViewComponent,
		MemberViewDetailsComponent,
		MemberViewClaimsComponent,
		MemberBulkUploadListComponent,
		MemberBulkUploadFormComponent,
		MemberBulkUploadViewComponent,
		TicketReportFormSimpleModalComponent,
		TicketReportRunModalComponent,
		TicketAssignModalComponent,
		TicketReportFormSubColumnModalComponent,
		TicketDashboardComponent,
		DashboardComponent,
		AwsQuicksiteComponent,
		MemberBulkUploadListComponent,
		MemberBulkUploadFormComponent,
		MemberBulkUploadViewComponent,
		DashboardTotalComponent,
		TicketDuplicateWarningModalComponent,
		AiChatWidgetComponent,
		AgentAdminViewComponent,
		AgentViewClaimsComponent,
		AgentViewDetailsComponent,
		AgentAdminViewAppRolesComponent,
		AgentAdminViewTicketRolesComponent,
		EmployerViewComponent,
		EmployerViewDetailsComponent,
		HierarchyInputComponent,
		DynamicFormInputHierarchyComponent,
		BankListComponent,
		BankFormComponent,
		HierarchyInputComponent,
		DynamicFormInputHierarchyComponent,
		TicketFormSectionOperationsComponent,
		AnalyticsListComponent,
		AnalyticsLandingPageComponent,
		AgentSelfComponent,
		TicketSearchModalComponent,
		PreviewModalComponent,
		TableComponent,
		ProductListComponent,
		ProductViewComponent,
		ProductEditComponent,
		ProductScheduleListComponent,
		ProductScheduleViewComponent,
		BankDepositListComponent,
		BankDepositViewComponent,
		// BenefitPaymentApprovalViewComponent,
		PolicyPaymentListComponent,
		PolicyPaymentViewComponent,
		BankPaymentListComponent,
		BankPaymentViewComponent,
		BenefitPaymentApprovalSettingComponent,
		RouteOutletPassthroughComponent,
		TicketMemberSearchByPolicyComponent,
		TicketMemberSearchByMemberComponent,
		TicketPickerComponent,
		BenefitPaymentListComponent,
		BenefitPaymentApprovalListComponent,
		ProductEditRuleModalComponent,
		ProductEditOfferModalComponent,
		ProductEditExtendedModalComponent,
		DynamicGenericEntityListComponent,
		DynamicGenericEntityFormComponent,
		DynamicFormInputDependantListComponent,
		ProductEditBankAccountModalComponent,
		TicketCommunicationDisplayModalComponent,
		TicketsViewHistoryComponent,
		PolicyNewComponent,
		PolicyExtendedCoverModalComponent,
		PolicyEditComponent,
		PolicySearchModalComponent,
		MemberViewPoliciesComponent,
		DynamicFormInputIdNumberOfLivingPersonComponent,
		DynamicFormInputIdNumberOfDeceasedPersonComponent,
		TicketQuestionnaireFormComponent,
		TicketQuestionnaireViewComponent,
		FinanceHomeComponent,
		FinanceProductViewComponent,
		FinanceProductCaptureDepositAmountComponent,
		FinanceProductScheduleFormatComponent,
		PolicyAddDependantModalComponent,
		FinanceProductScheduleProgressComponent,
		DynamicFormInputIcd10Component,
		PolicyBeneficiaryModalComponent,
		ForcePasswordChangeComponent,
		DashboardChartBarComponent,
		DashboardChartLineComponent,
		DashboardChartPieComponent,
		DashboardChartGaugeComponent,
		DashboardChartScatterComponent,
		DashboardTableComponent,
		DashboardEditorComponent,
		DashboardListComponent,
		DashboardComponentListComponent,
		DashboardComponentEditorComponent,
		TicketInvoiceApprovalListComponent,
		TicketInvoiceListComponent,
		TicketInvoiceApprovalSettingComponent,
		SbPublicComponent,
		SbDisabilityComponent,
		SbStilComponent,
		DynamicFormInputServiceProviderIdComponent,
	],
	imports: [
		LayoutModule,
		BrowserModule,
		BrowserAnimationsModule,
		NgbModule,
		RouterModule.forRoot(routes, { useHash: false }),
		GridsterModule,
		FontAwesomeModule,
		FormsModule,
		ReactiveFormsModule,
		NgbDropdownModule,
		NgbCollapseModule,
		NgbProgressbarModule,
		NgbDatepickerModule,
		NgxChartsModule,
		IconsProviderModule,
		NzLayoutModule,
		NzMenuModule,
		NzTableModule,
		NzTabsModule,
		NzTagModule,
		NzBreadCrumbModule,
		NzUploadModule,
		NzProgressModule,
		NzInputModule,
		NzCardModule,
		NzDescriptionsModule,
		NzEmptyModule,
		NzTimelineModule,
		NzRadioModule,
		HighchartsChartComponent,
		NzPageHeaderModule,
		NzFormModule,
		NzSelectModule,
		NzModalModule,
		NzDividerModule,
		NzCheckboxModule,
		NzButtonModule,
		NzToolTipModule,
		NzDatePickerModule,
		NzBadgeModule,
		NzCollapseModule,
		NzStepsModule,
		NzGridModule,
		NzSwitchModule,
		NzDrawerModule,
		NzTimePickerModule,
		NzSubmenuNoneInlineChildComponent,
		NzAlertModule,
		MonacoEditorModule.forRoot(),
		EmailBodyEditorComponent,
		NzListModule,
		NzSpinModule,
		NzAvatarModule,
		NzSpaceComponent,
		DragDropModule,
		NgbPopoverModule,
		NzFloatButtonModule,
		NzCommentModule,
		NgbAccordionModule,
		NzInputNumberModule,
		NzStatisticModule,
		NzSpaceModule,
		NzTreeModule,
		NzTreeSelectModule,
		NzDropDownModule,
		NzSkeletonModule,
		NzResultModule,
		NzPopconfirmModule,
		NzStatisticModule,
		NzGridModule,
		NzTagModule,
		NzIconModule,
		NzProgressModule,
		NzDatePickerModule,
		NzButtonModule,
		NzSpaceModule,
		NzBadgeModule,
		NzToolTipModule,
		NzEmptyModule,
		NzDividerModule,
		NzAvatarModule,
		NzMessageContainerComponent,
		NgxEchartsModule,
	],
	providers: [
		provideClientHydration(),
		{ provide: NZ_I18N, useValue: en_US },
		provideAnimations(),
		provideAnimationsAsync(),
		provideHttpClient(withInterceptorsFromDi()),
		provideHighcharts(),
		provideEchartsCore({ echarts }),
		CurrencyPipe,
	],
	bootstrap: [AppComponent],
})
export class AppModule {
	constructor(library: FaIconLibrary) {
		library.addIconPacks(fas);
	}
}
